/* 曹操傳・第 7 章／劉備傳・第 4 章：白馬與延津（200 年）
 * 由西往東的平野。西邊是曹軍，中段是白馬（顏良的陣在路中央），東南是延津的南坂（曹操把輜重擺在路上誘敵）。 */
export const YAN = [4300, 2400], BAIT = [6600, 3000], SLOPE = [5800, 2300], WEN = [8200, 3200];
export default {
  id: 'baima', name: '白馬', W: 9000, H: 4800, seed: 200,
  bases: [[800, 2400], [8400, 2400]],
  roads: [{ pts: [[800, 2400], [2400, 2400], YAN, [5400, 2600], BAIT, [8400, 3200]], w: 170 }, { pts: [[5400, 2600], SLOPE], w: 110 }],
  rocks: [[2600, 1200, 420, 200], [2700, 3700, 420, 200], [6000, 1300, 400, 200], [7400, 4200, 380, 180], [SLOPE[0] + 250, SLOPE[1] - 260, 300, 150]],
  woods: 0.25,
  sight: 0.85,
  clearings: [[YAN[0], YAN[1], 900], [BAIT[0], BAIT[1], 700], [SLOPE[0], SLOPE[1], 300], [800, 2400, 500]],
  tents: [{ x: 800, y: 2400, n: 6, r: 380, col: '#3b5a99', flag: '曹' }, { x: YAN[0] + 700, y: YAN[1] - 500, n: 6, r: 360, col: '#7a5a2a', flag: '顏' }],
  fields: [[3000, 3300, 600, 300], [6400, 1800, 560, 260, '#86803f']],
  grass: [[SLOPE[0] - 150, SLOPE[1] + 80, 240, 110], [3500, 1700, 240, 110]],
};
